import React from "react";
import LocalizedLink from "../containers/LocalizedLink";

//import Button from "./shared/Button";
/*
<Button
  additionalClassName="folder__slider-left button--icon"
  icon="button__icon--arrow-right i-arrow-right-light"
  onClick="href=/support/business"
/>
*/
const Support = props => {
  return (
    <div className="grid grid--3 grid--double">
      <LocalizedLink className="grid__item" to="/support/business">
        <div className="flex h-100 items-center support__hometitle">
          <div className="black center f3 font-light">
            {props.t("titleBusinessQuestion")}
          </div>
          <div className="">
            {/**<Button
              additionalClassName="folder__slider-left button--icon"
              icon="button__icon--arrow-right i-arrow-right-light"
              onClick="href=/support/business"
            />
            */}
          </div>
        </div>
      </LocalizedLink>

      <LocalizedLink className="grid__item" to="/support/technical">
        <div className="flex h-100 items-center support__hometitle">
          <div className="black center f3 font-light">
          {props.t("titleTechnicalQuestion")}</div>
          <div className="">
            {/**<Button
            additionalClassName="folder__slider-left button--icon"
            icon="button__icon--arrow-right i-arrow-right-light"
            onClick="href=/support/business"
          />
          */}
          </div>
        </div>
      </LocalizedLink>

      <LocalizedLink className="grid__item" to="/support/acoustic">
        <div className="flex h-100 items-center support__hometitle">
          <div className="black center f3 font-light">
            {props.t("titleAcousticQuestion")}
          </div>
          <div className="">
            {/**<Button
            additionalClassName="folder__slider-left button--icon"
            icon="button__icon--arrow-right i-arrow-right-light"
            onClick="href=/support/business"
          />
          */}
          </div>
        </div>
      </LocalizedLink>
    </div>
  );
};

export default Support;



// WEBPACK FOOTER //
// ./src/components/Support.js